/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React from 'react';
import cn from 'classnames';
import moment from 'moment';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import CurrencySign from 'components/price/CurrencySign.component';
import SM from 'components/sidebar/appointment/wizard/Wizard.module.scss';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';

import { validatePrice } from 'lib/validators';
import DropdownContainer from 'onboarding/common/forms/common/Popup';

import CN from './RoleCheckbox.module.scss';

class RoleCheckbox extends React.Component {
  constructor(props) {
    super(props);

    const applicationHours = [];
    const processingHours = [];
    let duration = '';
    let processing = '';

    let checked = false;
    if (this.props.service && this.props.service.role_executions) {
      const service = Object.assign({}, this.props.service);
      for (let i = 0; i < service.role_executions.length; i += 1) {
        if (this.props.role.id === service.role_executions[i].role_id) {
          checked = true;
          duration = moment(props.service.role_executions[i].duration, 'hh:mm:ss').format('hh:mm');
          processing = moment(props.service.role_executions[i].processing, 'hh:mm:ss').format('hh:mm');
          break;
        }
      }
    }
    for (let i = 0; i <= 32; i += 1) {
      const hour = moment('00:00', 'HH:mm')
        .add(15 * i, 'minutes')
        // .local()
        .format('HH:mm'); // ("LT")
      if (i !== 0) {
        applicationHours.push({
          id: i,
          name: hour,
          active: duration === hour,
        });
      }
      processingHours.push({
        id: i,
        name: hour,
        active: processing === hour,
      });
    }
    this.state = {
      checked,
      applicationPopupModal: false,
      processingPopupModal: false,
      applicationHours,
      errorMessage: '',
      processingHours,
      isProcessingSelected: false,
      priceError: false,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const applicationHours = [];
    const processingHours = [];
    let duration = '';
    let processing = '';
    if (nextProps.service && nextProps.service.role_executions) {
      const service = Object.assign({}, nextProps.service);
      for (let i = 0; i < service.role_executions.length; i += 1) {
        if (nextProps.role.id === service.role_executions[i].role_id) {
          duration = moment(nextProps.service.role_executions[i].duration, 'hh:mm:ss').format('hh:mm');
          processing = moment(nextProps.service.role_executions[i].processing, 'hh:mm:ss').format('hh:mm');
          break;
        }
      }
    }
    for (let i = 0; i <= 32; i += 1) {
      const hour = moment('00:00', 'HH:mm')
        .add(15 * i, 'minutes')
        // .local()
        .format('HH:mm'); // ("LT")
      if (i !== 0) {
        applicationHours.push({
          id: i,
          name: hour,
          active: duration === hour,
        });
      }
      processingHours.push({
        id: i,
        name: hour,
        active: processing === hour,
      });
    }
    this.setState({ applicationHours, processingHours });
  }

  onCheckboxChange = () => {
    if (!this.props.readOnly) {
      this.props.onClick(this.props.role.id);
      this.setState({ checked: !this.state.checked });
    }
  };

  onPriceChange = (event) => {
    if (!this.props.readOnly) {
      const price = event.target.value;

      if (!validatePrice(price)) {
        this.setState({ priceError: true });
        this.props.onPriceChange(this.props.role.id, '');
      } else {
        this.setState({ priceError: false });
      }
      this.props.onPriceChange(this.props.role.id, price);
    }
  };

  onPriceBlur = (event) => {
    const price = event.target.value;
    if (!validatePrice(price)) {
      this.setState({
        errorMessage: this.props.t('composite.addService.roleCheckbox.modalErrorMessage'),
        priceError: true,
      });
      this.props.onPriceChange(this.props.role.id, '');
    } else {
      this.setState({ priceError: false });
    }

    if (!this.props.readOnly) void this.props.onPriceBlur(price);
  };

  onApplicationChange = (item) => {
    if (!this.props.readOnly) {
      this.setState({ applicationPopupModal: false });
      this.props.onApplicationChange(this.props.role.id, item.name);
    }
  };

  onProcessingChange = (item) => {
    if (!this.props.readOnly) {
      this.setState({
        processingPopupModal: false,
        isProcessingSelected: item.name && item.name !== fromAnyToString('00:00'),
      });
      this.props.onProcessingChange(this.props.role.id, item.name);
    }
  };

  hideError = () => {
    this.setState({ errorMessage: '' });
  };

  render() {
    const { errorMessage, applicationHours, processingHours, applicationPopupModal, checked, processingPopupModal, isProcessingSelected, priceError } = this.state;
    const { role, service, t } = this.props;

    const { id: roleId, name: roleName } = role;
    const serviceId = service && service.id;
    const activeColor = checked ? '#080b0f' : '#b3b3b3';
    const checkboxId = `${roleName}-${roleId}-${serviceId || 'unknown'}`;

    let roleExecution;
    if (service && service.role_executions) {
      const svc = Object.assign({}, service);
      for (let i = 0; i < svc.role_executions.length; i += 1) {
        if (roleId === svc.role_executions[i].role_id) {
          roleExecution = svc.role_executions[i];
          break;
        }
      }
    }

    return (
      <div data-bem="RoleCheckbox" className="rounded-border-wrap">
        <SalonModal tag="RoleCheckbox__error-modal" isOpen={errorMessage} withFooter>
          <SalonModal.Body>
            <IconStatus variant="alert" width="lg">
              <Icon variant="alert" width="l1" />
            </IconStatus>
            <div className={SM.modalContent}>
              <div className={SM.modalTitle}>{t('common.error')}</div>
              <div className={SM.modalText}>{errorMessage}</div>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <Button variant="outlineForce" onClick={this.hideError} xSpace>
              {t('common.buttons.closeUpp')}
            </Button>
          </SalonModal.Footer>
        </SalonModal>

        <div className="rank-list-item">
          <div className="checkbox-switch-wrap">
            <input type="checkbox" className="checkbox-switch" id={checkboxId} onChange={this.onCheckboxChange} checked={checked} />
            <label style={{ color: activeColor }} htmlFor={checkboxId}>
              {roleName}
            </label>
          </div>
          {checked && (
            <div className="rank-dropdown">
              <div className="list-sub-item-wrap">
                <div className={CN.inputLabel}>
                  {t('composite.addService.roleCheckbox.price')} ({t('composite.addService.roleCheckbox.in')} <CurrencySign />)
                </div>
                {roleExecution && (
                  <input
                    type="text"
                    placeholder="70"
                    value={roleExecution.price}
                    id="PriceRole-2"
                    data-cy="PriceRole-2-role"
                    onChange={this.onPriceChange}
                    onBlur={this.onPriceBlur}
                    autoComplete="off"
                    inputMode="decimal"
                    className={cn({
                      [CN.input]: true,
                      [CN.inputError]: priceError,
                    })}
                  />
                )}
                {!roleExecution && (
                  <input
                    type="text"
                    placeholder="70"
                    id="PriceRole-2"
                    data-cy="PriceRole-2-noRole"
                    onChange={this.onPriceChange}
                    autoComplete="off"
                    inputMode="decimal"
                    className={cn({
                      [CN.input]: true,
                      [CN.inputError]: priceError,
                    })}
                  />
                )}
              </div>
              <div className="list-sub-item-wrap dropdown-mobile dropdown-sm">
                <div className={CN.inputLabel}>{t('composite.addService.roleCheckbox.applicationTimeLabel')}</div>
                {applicationPopupModal && (
                  <DropdownContainer
                    title={t('composite.addService.roleCheckbox.applicationTime')}
                    items={applicationHours}
                    onClose={() => this.setState({ applicationPopupModal: false })}
                    onSelectItem={this.onApplicationChange}
                  />
                )}
                {roleExecution && (
                  <input
                    type="tel"
                    placeholder="45"
                    readOnly
                    value={moment(roleExecution.duration, 'HH:mm:ss').format('HH:mm')}
                    id="AppRole-2"
                    data-cy="AppRole-2-role"
                    onClick={() => this.setState({ applicationPopupModal: true })}
                  />
                )}
                {!roleExecution && <input type="tel" placeholder="45" id="AppRole-2" data-cy="AppRole-2-norole" onChange={this.onApplicationChange} />}
              </div>
              <div className="list-sub-item-wrap dropdown-mobile dropdown-sm">
                <div className={CN.inputLabel}>
                  {t('composite.addService.roleCheckbox.processTimeLabel')}
                  {isProcessingSelected && <div className={CN.processingText}>{t('composite.addService.roleCheckbox.processNoteText')}</div>}
                </div>

                {processingPopupModal && (
                  <DropdownContainer
                    title={t('composite.addService.roleCheckbox.processTime')}
                    items={processingHours}
                    onClose={() => this.setState({ processingPopupModal: false })}
                    onSelectItem={this.onProcessingChange}
                  />
                )}
                {roleExecution && (
                  <input
                    type="tel"
                    placeholder="45"
                    readOnly
                    value={roleExecution.processing === '00:00:00' ? t('common.none') : moment(roleExecution.processing, 'HH:mm:ss').format('HH:mm')}
                    id="ProRole-2"
                    data-cy="ProRole-2-role"
                    onClick={() => this.setState({ processingPopupModal: true })}
                  />
                )}
                {!roleExecution && <input type="tel" placeholder="45" id="ProRole-2" data-cy="ProRole-2-norole" onChange={this.onProcessingChange} />}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const RoleCheckboxHoc = withTranslation()(RoleCheckbox);

export default RoleCheckboxHoc;
